import { ReactNode } from "react";

export type Clinician = {
    name: string;
    imageUrl: string;
    experience?: ReactNode;
    highlight?: string;
};

export const CLINICIANS: Clinician[] = [
    {
        name: "Dr. Sarah Daccarett, MD",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082025/clinicians/Dr._Sarah_Daccarett_MD_za8uuq.webp",
        highlight: "Founder & CEO, Inner Balance",
    },
    {
        name: "Barry Aron, MD, FACOG, MSCP",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082025/clinicians/Barry_Aron_MD_FACOG_MSCP_foextc.webp",
        experience: "30+ years in OB/GYN & menopause care",
    },
    {
        name: "Bridgette Baker, MD",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082026/clinicians/Bridgette_Baker_MD_utz4tu.webp",
        experience: "15+ years in family practice & women's health",
    },
    {
        name: "Kendall King, BSN, RN",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082026/clinicians/Kendall_King_BSN_RN_ign1bc.webp",
        experience: "20+ years in nursing & healthcare leadership",
    },
    {
        name: "Brooke Tucker, RN",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082026/clinicians/Brooke_Tucker_RN_lcfsz4.webp",
        experience: "20+ years in women's health care",
    },
    {
        name: "Amberlie, BSN, RN",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082026/clinicians/Amberlie_BSN_RN_lcoc2d.webp",
        experience: <>18+ years in healthcare, <br />pediatrics & women&apos;s health</>,
    },
    {
        name: "Michelle Ballard, BSN, RN, VA-BC",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082025/clinicians/Michelle_Ballard_BSN_RN_VA-BC_a3i0ks.webp",
        experience: <>30+ years in cardiac, vascular, labor <br />and delivery care</>,
    },
    {
        name: "Jennica Johnson, BSN, RN",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082025/clinicians/Jennica_Johnson_BSN_RN_kogbdp.webp",
        experience: "5+ years in women's wellness care",
    },
    {
        name: "Joy Peterson, NP",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790082025/clinicians/Joy_Peterson_NP_m2hkvp.webp",
        experience: "Women's health, mental health & ADHD; treats hormonal-emotional imbalances",
    },
];
